import { Component, Inject, signal, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { IAnnouncementItem } from '@lla-platform/announcements/announcements-data-access'
import { CommonService } from '@lla-platform/core/core-util'

@Component({
  selector: 'lla-loud-announcement-dialog',
  templateUrl: './loud-announcement-dialog.component.html',
  styleUrls: ['./loud-announcement-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoudAnnouncementDialogComponent {
  protected lightboxIndex = signal<number | undefined>(undefined)

  constructor(
    public dialogRef: MatDialogRef<LoudAnnouncementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { item: IAnnouncementItem },
    protected commonService: CommonService
  ) {}

  // Every close path (X, button, backdrop, Esc) funnels through afterClosed —
  // the opener marks the announcement as read there.
  protected closeDialog() {
    this.dialogRef.close()
  }

  // Navigation is the opener's job — it reads this result in afterClosed.
  protected viewInAnnouncements() {
    this.dialogRef.close('view')
  }
}
